import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick", "setIsModalOpen", "isModalOpen", "iconTooltipLabel"];
// @flow

/*
 * Licensed Materials - Property of IBM
 * 5724-Q36
 * (c) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import * as React from 'react';
import PropTypes from 'prop-types';
import { Column16 } from '@carbon/icons-react';
import { Button } from 'carbon-components-react';
import { pkg } from '../../../../../settings';
var blockClass = "".concat(pkg.prefix, "--datagrid");

var ButtonWrapper = function ButtonWrapper(_ref) {
  var _onClick = _ref.onClick,
      setIsModalOpen = _ref.setIsModalOpen,
      isModalOpen = _ref.isModalOpen,
      _ref$iconTooltipLabel = _ref.iconTooltipLabel,
      iconTooltipLabel = _ref$iconTooltipLabel === void 0 ? 'Customize columns' : _ref$iconTooltipLabel,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Button, _extends({}, rest, {
    renderIcon: Column16,
    iconDescription: iconTooltipLabel,
    tooltipPosition: "left",
    kind: "ghost",
    hasIconOnly: true,
    "test-id": "".concat(blockClass, "__customize-columns-trigger"),
    onClick: function onClick() {
      setIsModalOpen(!isModalOpen);

      if (typeof _onClick === 'function') {
        _onClick();
      }
    }
  }));
};

ButtonWrapper.propTypes = {
  iconTooltipLabel: PropTypes.string,
  isModalOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  setIsModalOpen: PropTypes.func.isRequired
};
export default ButtonWrapper;